/**
 * Meliusly PDP buy box — gallery, variant selection, ATC, delivery estimate,
 * and the buy-box accordions. Ported from DynamicPDP.tsx. Vanilla JS, no deps.
 */
(function () {
  var DAY_NAMES = ['Sun', 'Mon', 'Tue', 'Wed', 'Thurs', 'Fri', 'Sat'];
  var MONTH_NAMES = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  function money(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function initProduct(root) {
    var variantsEl = root.querySelector('[data-mel-variants]');
    var optionsEl = root.querySelector('[data-mel-options]');
    if (!variantsEl) return;

    var variants;
    try { variants = JSON.parse(variantsEl.textContent); } catch (e) { variants = []; }
    var options;
    try { options = optionsEl ? JSON.parse(optionsEl.textContent) : []; } catch (e) { options = []; }
    if (!variants.length) return;

    var cheapest = variants.reduce(function (a, b) { return b.price < a.price ? b : a; }, variants[0]);
    var selected = cheapest;

    // ---- gallery -------------------------------------------------------
    var mainImages = Array.prototype.slice.call(root.querySelectorAll('[data-mel-main-images] > *'));
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-mel-thumb]'));
    var imgPrev = root.querySelector('[data-mel-img-prev]');
    var imgNext = root.querySelector('[data-mel-img-next]');
    var thumbUp = root.querySelector('[data-mel-thumb-up]');
    var thumbDown = root.querySelector('[data-mel-thumb-down]');
    var thumbsTrack = root.querySelector('[data-mel-thumbs]');
    var imageIndex = 0;

    function setImage(index) {
      if (index < 0 || index >= mainImages.length) return;
      imageIndex = index;
      mainImages.forEach(function (img, i) {
        if (i === index) {
          img.classList.remove('pointer-events-none', 'opacity-0');
          img.classList.add('opacity-100');
        } else {
          img.classList.remove('opacity-100');
          img.classList.add('pointer-events-none', 'opacity-0');
        }
      });
      thumbs.forEach(function (thumb, i) {
        if (i === index) {
          thumb.classList.add('border-2', 'border-[#0268a0]');
          thumb.classList.remove('border-0', 'hover:opacity-80');
        } else {
          thumb.classList.remove('border-2', 'border-[#0268a0]');
          thumb.classList.add('border-0', 'hover:opacity-80');
        }
      });
      if (imgPrev) imgPrev.classList.toggle('hidden', index <= 0);
      if (imgNext) imgNext.classList.toggle('hidden', index >= mainImages.length - 1);
    }

    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () { setImage(i); });
    });
    if (imgPrev) imgPrev.addEventListener('click', function (e) { e.stopPropagation(); setImage(imageIndex - 1); });
    if (imgNext) imgNext.addEventListener('click', function (e) { e.stopPropagation(); setImage(imageIndex + 1); });
    if (thumbUp && thumbsTrack) thumbUp.addEventListener('click', function () { thumbsTrack.scrollBy({ top: -200, behavior: 'smooth' }); });
    if (thumbDown && thumbsTrack) thumbDown.addEventListener('click', function () { thumbsTrack.scrollBy({ top: 200, behavior: 'smooth' }); });
    setImage(0);

    // ---- price / ATC / delivery ----------------------------------------
    var compareWrap = root.querySelector('[data-mel-compare-wrap]');
    var comparePriceEl = root.querySelector('[data-mel-compare-price]');
    var currentPriceEl = root.querySelector('[data-mel-current-price]');
    var savePill = root.querySelector('[data-mel-save-pill]');
    var saveAmountEl = root.querySelector('[data-mel-save-amount]');
    var monthlyPriceEl = root.querySelector('[data-mel-monthly-price]');
    var atcButton = root.querySelector('[data-mel-atc]');
    var atcLabel = root.querySelector('[data-mel-atc-label]');
    var sizeLabelEl = root.querySelector('[data-mel-size-label]');

    function renderVariant(variant) {
      selected = variant;
      var hasSavings = typeof variant.compareAtPrice === 'number' && variant.compareAtPrice > variant.price;

      if (compareWrap) compareWrap.style.display = hasSavings ? '' : 'none';
      if (comparePriceEl && hasSavings) comparePriceEl.textContent = money(variant.compareAtPrice);
      if (currentPriceEl) currentPriceEl.textContent = money(variant.price);
      if (savePill) savePill.style.display = hasSavings ? '' : 'none';
      if (saveAmountEl && hasSavings) saveAmountEl.textContent = ((variant.compareAtPrice - variant.price) / 100).toFixed(2);
      if (monthlyPriceEl) monthlyPriceEl.textContent = (variant.price / 400).toFixed(2);
      if (sizeLabelEl) sizeLabelEl.textContent = variant.title;

      if (atcButton) {
        atcButton.setAttribute('data-variant-id', variant.id);
        atcButton.disabled = !variant.available;
        atcButton.classList.toggle('bg-[#0268a0]', variant.available);
        atcButton.classList.toggle('bg-[#A0C4D9]', !variant.available);
      }
      if (atcLabel) {
        atcLabel.textContent = variant.available ? 'Add To Cart • ' + money(variant.price) : 'Sold Out';
      }

      updateVariantUI(variant);
    }

    // ---- variant selector UI -------------------------------------------
    var selectorRoot = root.querySelector('[data-mel-variant-mode]');
    var mode = selectorRoot ? selectorRoot.getAttribute('data-mel-variant-mode') : null;

    function findVariant(predicate) {
      for (var i = 0; i < variants.length; i++) {
        if (predicate(variants[i])) return variants[i];
      }
      return null;
    }

    function updateVariantUI(variant) {
      if (mode === 'grid') {
        Array.prototype.slice.call(root.querySelectorAll('[data-mel-variant-card]')).forEach(function (card) {
          var isSelected = card.getAttribute('data-mel-variant-id') === String(variant.id);
          card.classList.toggle('border-2', isSelected);
          card.classList.toggle('border-[#0268a0]', isSelected);
          card.classList.toggle('border', !isSelected);
          card.classList.toggle('border-[rgba(34,34,34,0.1)]', !isSelected);
        });
      } else if (mode === 'dropdown') {
        var select = root.querySelector('[data-mel-variant-select]');
        if (select) select.value = String(variant.id);
      } else if (mode === 'two-layer') {
        var primaryEl = root.querySelector('[data-mel-primary-value]');
        var secondaryEl = root.querySelector('[data-mel-secondary-value]');
        if (primaryEl) primaryEl.textContent = variant.option1;
        if (secondaryEl) secondaryEl.textContent = variant.option2;
        Array.prototype.slice.call(root.querySelectorAll('[data-mel-primary-option]')).forEach(function (btn) {
          var isSelected = btn.getAttribute('data-mel-primary-option') === variant.option1;
          btn.classList.toggle('border-2', isSelected);
          btn.classList.toggle('border-[#0268a0]', isSelected);
          btn.classList.toggle('border', !isSelected);
          btn.classList.toggle('border-[rgba(34,34,34,0.15)]', !isSelected);
        });
        var secondarySelect = root.querySelector('[data-mel-secondary-select]');
        if (secondarySelect) {
          // Repopulate options for the newly selected primary value.
          var values = [];
          variants.forEach(function (v) {
            if (v.option1 === variant.option1 && values.indexOf(v.option2) === -1) values.push(v.option2);
          });
          secondarySelect.innerHTML = '';
          values.forEach(function (value) {
            var opt = document.createElement('option');
            opt.value = value;
            opt.textContent = value;
            if (value === variant.option2) opt.selected = true;
            secondarySelect.appendChild(opt);
          });
        }
      }
    }

    if (mode === 'grid') {
      Array.prototype.slice.call(root.querySelectorAll('[data-mel-variant-card]')).forEach(function (card) {
        card.addEventListener('click', function () {
          var id = card.getAttribute('data-mel-variant-id');
          var variant = findVariant(function (v) { return String(v.id) === id; });
          if (variant) renderVariant(variant);
        });
      });
    } else if (mode === 'dropdown') {
      var dropdown = root.querySelector('[data-mel-variant-select]');
      if (dropdown) {
        dropdown.addEventListener('change', function () {
          var variant = findVariant(function (v) { return String(v.id) === dropdown.value; });
          if (variant) renderVariant(variant);
        });
      }
    } else if (mode === 'two-layer') {
      Array.prototype.slice.call(root.querySelectorAll('[data-mel-primary-option]')).forEach(function (btn) {
        btn.addEventListener('click', function () {
          var primary = btn.getAttribute('data-mel-primary-option');
          var variant = findVariant(function (v) { return v.option1 === primary && v.option2 === selected.option2; })
            || findVariant(function (v) { return v.option1 === primary; });
          if (variant) renderVariant(variant);
        });
      });
      var secondarySelect = root.querySelector('[data-mel-secondary-select]');
      if (secondarySelect) {
        secondarySelect.addEventListener('change', function () {
          var variant = findVariant(function (v) { return v.option1 === selected.option1 && v.option2 === secondarySelect.value; });
          if (variant) renderVariant(variant);
        });
      }
    }

    // ---- delivery estimate ----------------------------------------------
    var deliveryDateEl = root.querySelector('[data-mel-delivery-date]');
    if (deliveryDateEl) {
      var daysOffset = parseInt(root.getAttribute('data-mel-delivery-days'), 10);
      if (isNaN(daysOffset)) daysOffset = 5;
      var delivery = new Date();
      delivery.setDate(delivery.getDate() + daysOffset);
      deliveryDateEl.textContent = DAY_NAMES[delivery.getDay()] + ', ' + delivery.getDate() + ' ' + MONTH_NAMES[delivery.getMonth()];
    }

    // ---- add to cart ------------------------------------------------------
    if (atcButton) {
      atcButton.addEventListener('click', function () {
        if (atcButton.disabled || !window.MeliuslyCart) return;
        atcButton.disabled = true;
        window.MeliuslyCart.add(selected.id, 1).then(function () {
          atcButton.disabled = !selected.available;
        }).catch(function () {
          atcButton.disabled = !selected.available;
        });
      });
    }

    // ---- deep link ?variant= ---------------------------------------------
    var params = new URLSearchParams(window.location.search);
    var variantParam = params.get('variant');
    if (variantParam) {
      var target = variantParam.toLowerCase().trim();
      var match = findVariant(function (v) {
        return v.title.toLowerCase().trim() === target ||
          (v.option1 && v.option1.toLowerCase().trim() === target) ||
          (v.option2 && v.option2.toLowerCase().trim() === target);
      });
      if (match) cheapest = match;
    }

    renderVariant(cheapest);

    // ---- buy box accordions ----------------------------------------------
    Array.prototype.slice.call(root.querySelectorAll('[data-mel-accordion-trigger]')).forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var wrap = trigger.parentElement;
        var content = wrap.querySelector('[data-mel-accordion-content]');
        var plus = wrap.querySelector('[data-mel-accordion-plus]');
        var minus = wrap.querySelector('[data-mel-accordion-minus]');
        var isOpen = content && !content.hidden;
        if (content) content.hidden = isOpen;
        if (plus) plus.classList.toggle('hidden', !isOpen);
        if (minus) minus.classList.toggle('hidden', isOpen);
      });
    });
  }

  function init() {
    Array.prototype.slice.call(document.querySelectorAll('[data-mel-product]')).forEach(initProduct);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
